import { assign } from "lodash";
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import { ZodSharedValidator } from "@medsurf/flat-validators";
import { BaseQuestionComponent } from '../base-question/base-question.component';

@Component({
    selector: 'medsurf-quiz-single-choice-question',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './single-choice-question.component.html',
    styleUrls: ['./single-choice-question.component.scss'],
    standalone: false
})
export class SingleChoiceQuestionComponent extends BaseQuestionComponent<FlatModels.QuestionEntityModels.SingleChoiceQuestion | FlatModels.QuestionEntityModels.LongListQuestion> {
  choices_expanded = false;
  override form = new FormGroup(
    {
      content: new FormControl(''),
      explanation: new FormControl(''),
      solution: new FormControl(0)
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.QuestionEntityModels.SingleChoiceQuestionSchema.pick({
          content: true,
          explanation: true,
          solution: true
        })
      ),
      updateOn: 'change'
    }
  );

  override updateForm() {
    if (this.index !== undefined && this.question) {
      let update = false;
      if (this.question.content !== this.form.value.content
        || this.question.explanation !== this.form.value.explanation
        || this.question.solution !== this.form.value.solution) {
        update = true;
      }
      if (update) {
        // Update Data
        this.form.reset(this.question);
        this.isSubmitted.set(false);
      }
    }
  }

  override onSubmit() {
    if (this.isSubmitted() || this.form.invalid || !this.question) {
      return;
    }
    this.isSubmitted.set(true);
    
    // Update Question
    const question = assign(this.question, this.form.value);

    // Request Update Question
    this.slideAuthorFacade.requestUpdateQuestion(question, 'history.question_update').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.form);
        this.isSubmitted.set(false);
      },
      next: () => {
        this.isSubmitted.set(false);
      }
    });
  }

  trackBy(index: number,
          item: FlatModels.ChoiceEntityModels.Choice) {
    return item.id + item.order || index;
  }

  onChoiceMoved(choices: FlatModels.ChoiceEntityModels.Choice[]) {
    this.slideAuthorFacade.requestRearrangeChoices(this.question, choices).subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
    });
  }

  onSolutionChange(index: number) {
    this.form.patchValue({ solution: index });
    this.onSubmit();
  }

  addChoice() {
    // Add Choice
    this.slideAuthorFacade.requestAddChoice(this.question, 'history.choice_add').subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
      next: () => {
        this.choices_expanded = true;
      }
    });
  }
}
